/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UnhideAgentMcpServerRequestBody,
  UnhideAgentMcpServerRequestBody$Outbound,
  UnhideAgentMcpServerRequestBody$outboundSchema,
} from "../components/unhideagentmcpserverrequestbody.js";

export type UnhideAgentMcpServerSecurity = {
  apikeyHeaderGramKey?: string | undefined;
};

export type UnhideAgentMcpServerRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Email address of the enrolled user, sent in the Gram-User-Email header. Required when authenticating with an org-scoped agent install key; ignored for a per-user key, whose owner is the enrolled user.
   */
  gramUserEmail?: string | undefined;
  unhideAgentMcpServerRequestBody: UnhideAgentMcpServerRequestBody;
};

/** @internal */
export type UnhideAgentMcpServerSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const UnhideAgentMcpServerSecurity$outboundSchema: z.ZodMiniType<
  UnhideAgentMcpServerSecurity$Outbound,
  UnhideAgentMcpServerSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function unhideAgentMcpServerSecurityToJSON(
  unhideAgentMcpServerSecurity: UnhideAgentMcpServerSecurity,
): string {
  return JSON.stringify(
    UnhideAgentMcpServerSecurity$outboundSchema.parse(
      unhideAgentMcpServerSecurity,
    ),
  );
}

/** @internal */
export type UnhideAgentMcpServerRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-User-Email"?: string | undefined;
  UnhideAgentMcpServerRequestBody: UnhideAgentMcpServerRequestBody$Outbound;
};

/** @internal */
export const UnhideAgentMcpServerRequest$outboundSchema: z.ZodMiniType<
  UnhideAgentMcpServerRequest$Outbound,
  UnhideAgentMcpServerRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramUserEmail: z.optional(z.string()),
    unhideAgentMcpServerRequestBody:
      UnhideAgentMcpServerRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramUserEmail: "Gram-User-Email",
      unhideAgentMcpServerRequestBody: "UnhideAgentMcpServerRequestBody",
    });
  }),
);

export function unhideAgentMcpServerRequestToJSON(
  unhideAgentMcpServerRequest: UnhideAgentMcpServerRequest,
): string {
  return JSON.stringify(
    UnhideAgentMcpServerRequest$outboundSchema.parse(
      unhideAgentMcpServerRequest,
    ),
  );
}
